import * as React from 'react';

import { useIsReplyScrollTarget } from '../../../utils/replyScrollContext';

type TUseScrollToReplyTargetParams = {
  messageId: string;
  messageRef: React.RefObject<HTMLDivElement | null>;
};

type TUseScrollToReplyTargetResult = {
  highlighted: boolean;
  onHighlightEnd: VoidFunction;
};

/**
 * Подскролл к сообщению из реплая и признак того, что его нужно подсветить.
 * Провайдер выставляет цель только когда вся нужная история догружена, поэтому скролл происходит один раз в конце.
 */
export const useScrollToReplyTarget = ({
  messageId,
  messageRef,
}: TUseScrollToReplyTargetParams): TUseScrollToReplyTargetResult => {
  const { isReplyTarget, clearReplyTargetMessage } = useIsReplyScrollTarget(messageId);

  React.useEffect(() => {
    if (!isReplyTarget) {
      return;
    }

    /**
     * ScrollContainer восстанавливает позицию скролла в ResizeObserver уже после эффектов,
     * поэтому скроллим следующей задачей — иначе позицию перебьёт восстановление
     */
    const timer = setTimeout(() => {
      messageRef.current?.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
    }, 0);

    return () => clearTimeout(timer);
  }, [isReplyTarget, messageRef]);

  return { highlighted: isReplyTarget, onHighlightEnd: clearReplyTargetMessage };
};
